import { useDispatch, useSelector } from "react-redux";
import "./Header.scss";
import { setAwsData, setLanguage, setNotificationData } from "../../Services/Redux/Reducer/Reducer";
import { useTranslation } from "react-i18next";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuIcon from "@mui/icons-material/Menu";
import { useEffect, useState } from "react";
import { useProSidebar } from "react-pro-sidebar";
import {
  API_RESPONSE,
  I18_TRANSLATION_COMMON,
  LANGUAGES,
  LAYOUTS,
  NUMBER_CONSTANTS,
  ROUTES,
  STORAGE_KEYS,
} from "../../Utilities/Constants/Constants";
import Avatar from "@mui/material/Avatar";
import img from "../../../Assets/Login/loginBanner.png";
import React from "react";
import {
  GetSessionStorageData,
  SetSessionStorageData,
  clearSessionStorage,
} from "../../Services/Helpers/Helper";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LanguageIcon from "@mui/icons-material/Language";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { axiosInstance } from "../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../Utilities/Constants/ApiEndpoints";

const Header = (props: any) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(API_RESPONSE.NULL);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { collapseSidebar } = useProSidebar();
  const [currentTitle, setCurrentTitle] = useState("");
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });
  const [showRedDot, setShowRedDot] = useState(API_RESPONSE.FALSE);
  const [coverData, setCoverData] = useState<any>({});

  // const socket: any = new WebSocket(`wss://phygital.way2smile.ae:8001/ws/notification/${GetSessionStorageData(STORAGE_KEYS.ID)}/`);
  // const socket:any= new WebSocket(`wss://learnandplay.way2smile.ae:8001/ws/notification/${GetSessionStorageData(STORAGE_KEYS.ID)}/`);

  useEffect(() => {
    let id: any = GetSessionStorageData(STORAGE_KEYS.ID);
    const socket: any = new WebSocket(process.env.REACT_APP_NOTIFICATION_WEB_SOCKET + id + '/');
    // getAwsCredentials();
    getCoverData();
    /* Works on socket establishment */
    socket.onopen = (event: any) => {
    };

    /* Listen to events for socket server */
    socket.onmessage = (event: any) => {
      if (event.data) {
        dispatch(
          setNotificationData(
            JSON.parse(event.data)
          ));
      }
      setShowRedDot(API_RESPONSE.TRUE);
    };

    /* Closes socket on killing component */
    /*  return () => {
       socket.close();
     } */

  }, []);

  const getAwsCredentials = () => {
    axiosInstance.get(API_END_POINTS.AWS_CREDENTIALS_LIST).then((response: any) => {
      let payload = {
        accessKey: "",
        secretKey: ""
      }
      dispatch(
        setAwsData(
          response.data.result.data
        ))
    })
  }

  const getCoverData = () => {
    axiosInstance.get(API_END_POINTS.COVER_IMAGE).then((response) => {
      setCoverData(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
    });
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(API_RESPONSE.NULL);
  };

  const onLogOut = () => {
    handleClose();
    clearSessionStorage();
    // socket.close();
    navigate(ROUTES.LOGIN);
  };

  /* Handling Language change */
  const onChangeLanguage = (languageToChange: any) => {
    dispatch(
      setLanguage(
        languageToChange === LANGUAGES.ENGLISH
          ? LANGUAGES.ENGLISH
          : LANGUAGES.ARABIC
      )
    );
    SetSessionStorageData(
      STORAGE_KEYS.LANGUAGE,
      languageToChange === LANGUAGES.ENGLISH
        ? LANGUAGES.ENGLISH
        : LANGUAGES.ARABIC
    );
    changeLanguage(
      languageToChange === LANGUAGES.ENGLISH
        ? LANGUAGES.ENGLISH_ABBRIVATION
        : LANGUAGES.ARABIC_ABBRIVATION
    );
  };

  useEffect(() => {
    defineRoutingName();
  }, [props]);

  const defineRoutingName = () => {
    switch (props.currentPage) {
      case "dashboard":
        setCurrentTitle("Dashboard");
        break;

      case "manage-sessions":
        setCurrentTitle("Manage Session");
        break;

      case "manage-bookings":
        setCurrentTitle("Manage Bookings");
        break;

      case "manage-documents":
        setCurrentTitle("Manage Documents");
        break;

      case "manage-discounts":
        setCurrentTitle("Manage Discounts");
        break;

      case "chat":
        setCurrentTitle("Manage Chats");
        break;
    }
  };


  const onClickNotification = () => {
    setShowRedDot(API_RESPONSE.FALSE);
    navigate(ROUTES.NOTIFICATIONS);
  }

  return (
    <>
      <div
        dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}
        className="header_wrapper"
      >
        <MenuIcon
          className="sidebar_menu_icon_toggle"
          onClick={() => collapseSidebar()}
        />
        {/* <div className="header_container"> */}

        <div className="title-wrap-header">{currentTitle}</div>
        <div className="language-profile-wrapper">
          {location.pathname !== ROUTES.ONBOARDING_SCREEN && (
            <div className="not-icon-wrapper">
              <NotificationsNoneIcon className="header-notification-icon" onClick={onClickNotification} />
              {showRedDot && <FiberManualRecordIcon className="red-dot" />}
            </div>
          )}
          <div className="language_toggle_button_container">
            <div
              /* onClick={() =>
                onChangeLanguage(
                  language === LANGUAGES.ENGLISH
                    ? LANGUAGES.ARABIC
                    : LANGUAGES.ENGLISH
                )
              } */
              className="language-selector"
            >
              <LanguageIcon className="language_icon_header" />
              <div>
                {/* language === LANGUAGES.ENGLISH
                  ? LANGUAGES.ARABIC
                  : */ LANGUAGES.ENGLISH}
              </div>
            </div>
          </div>
          <div className="admin-avatar-wrap">
            <Avatar alt="Admin" className="avatar" src={coverData.profile} />

            <div>
              <div
                className="admin-name"
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                {coverData.name}
                <ArrowDropDownIcon />
              </div>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {coverData.status !== "pending" && <MenuItem
                  onClick={() => {
                    navigate("/profile");
                    setAnchorEl(null);
                  }}
                >
                  {t("Profile")}
                </MenuItem>}
                {/* <MenuItem onClick={()=>onSendMessage('hi')}>{t("message")}</MenuItem> */}
                <MenuItem onClick={onLogOut}>{t("Logout")}</MenuItem>
              </Menu>
            </div>
          </div>
        </div>

        {/* </div> */}
      </div>
    </>
  );
};

export default Header;
